import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p421273111662354432',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
